export const removeTokenExpiredFromStorage = () => {
  localStorage.removeItem('tokenExpired');
};
